import Activities from '@/api/activities/activities'

const activities = new Activities()

const activitiesModule = {
  namespaced: true,
  state: {
    items: [],
    total: 0,
    load: false,
    loadSyncActivity: false,
    loadSyncAllActivity: false,
    LocalAssignmentsLookups: [],
    loadLocalAssignmentsLookups: false,
  },
  getters: {
    items(state) {
      return state.items
    },
    load(state) {
      return state.load
    },
    total(state) {
      return state.total
    },
    loadSyncActivity(state) {
      return state.loadSyncActivity
    },
    loadSyncAllActivity(state) {
      return state.loadSyncAllActivity
    },
    LocalAssignmentsLookups(state) {
      return state.LocalAssignmentsLookups
    },
    loadLocalAssignmentsLookups(state) {
      return state.loadLocalAssignmentsLookups
    },

  },

  mutations: {
    SET_LOAD: (state, load) => {
      state.load = load
    },
    SET_ITEMS: (state, items) => {
      state.items = items
    },
    SET_TOTAL_ACTIVITIES: (state, total) => {
      state.total = total
    },
    SET_LOAD_SYNC_ACTIVITY: (state, loadSyncActivity) => {
      state.loadSyncActivity = loadSyncActivity
    },
    SET_LOAD_SYNC_ALL_ACTIVITY: (state, loadSyncAllActivity) => {
      state.loadSyncAllActivity = loadSyncAllActivity
    },
    SET_LOCAL_ASSIGNMENTS_LOOKUPS: (state, LocalAssignmentsLookups) => {
      state.LocalAssignmentsLookups = LocalAssignmentsLookups
    },
    SET_LOAD_LOCAL_ASSIGNMENTS_LOOKUPS: (state, loadLocalAssignmentsLookups) => {
      state.loadLocalAssignmentsLookups = loadLocalAssignmentsLookups
    },
  },

  actions: {
    list({ commit }, query) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD', true)
        activities.list(query).then(response => {
          commit('SET_ITEMS', response)
          // Assuming response structure, adjust if needed based on actual API response
          // commit("SET_TOTAL_ACTIVITIES", response.total);
          commit('SET_LOAD', false)
          resolve(response)
        }).catch(error => {
          commit('SET_LOAD', false)
          reject(error)
        })
      })
    },
    get({ commit }, id) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD', true)
        activities.get(id).then(response => {
          commit('SET_LOAD', false)
          resolve(response)
        }).catch(error => {
          commit('SET_LOAD', false)
          reject(error)
        })
      })
    },
    syncActivity({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD_SYNC_ACTIVITY', true)
        activities.syncActivity(payload.id, payload.query).then(response => {
          commit('SET_LOAD_SYNC_ACTIVITY', false)
          resolve(response)
        }).catch(error => {
          commit('SET_LOAD_SYNC_ACTIVITY', false)
          reject(error)
        })
      })
    },
    syncAllActivity({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD_SYNC_ALL_ACTIVITY', true)
        activities.SyncAllActivity(payload.id).then(response => {
          commit('SET_LOAD_SYNC_ALL_ACTIVITY', false)
          resolve(response)
        }).catch(error => {
          commit('SET_LOAD_SYNC_ALL_ACTIVITY', false)
          reject(error)
        })
      })
    },

    store({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD', true)
        activities.store(data).then(response => {
          commit('SET_LOAD', false)
          resolve(response)
        }).catch(error => {
          commit('SET_LOAD', false)
          reject(error)
        })
      })
    },
    update({ commit }, { id, data }) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD', true)
        activities.update(id, data).then(response => {
          commit('SET_LOAD', false)
          resolve(response)
        }).catch(error => {
          commit('SET_LOAD', false)
          reject(error)
        })
      })
    },
    remove({ commit }, id) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD', true)
        activities.remove(id).then(response => {
          commit('SET_LOAD', false)
          resolve(response)
        }).catch(error => {
          commit('SET_LOAD', false)
          reject(error)
        })
      })
    },
    LMSLookups({ commit }, id) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD', true)
        activities.LMSLookups(id).then(response => {
          commit('SET_LOAD', false)
          resolve(response)
        }).catch(error => {
          commit('SET_LOAD', false)
          reject(error)
        })
      })
    },
    LocalAssignmentsLookups({ commit }, id) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD_LOCAL_ASSIGNMENTS_LOOKUPS', true)
        activities.LocalAssignmentsLookups(id).then(response => {
          commit('SET_LOCAL_ASSIGNMENTS_LOOKUPS', response.data)
          console.log('LocalAssignmentsLookups response:', response.data)
          commit('SET_LOAD_LOCAL_ASSIGNMENTS_LOOKUPS', false)
          resolve(response)
        }).catch(error => {
          commit('SET_LOAD_LOCAL_ASSIGNMENTS_LOOKUPS', false)
          reject(error)
        })
      })
    },
    LMSCoursesLookups({ commit }, id) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD', true)
        activities.LMSCoursesLookups(id).then(response => {
          commit('SET_LOAD', false)
          resolve(response)
        }).catch(error => {
          commit('SET_LOAD', false)
          reject(error)
        })
      })
    },
    LMSAssignmentsLookups({ commit }, { id, course_id }) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD', true)
        activities.LMSAssignmentsLookups(id, course_id).then(response => {
          commit('SET_LOAD', false)
          resolve(response)
        }).catch(error => {
          commit('SET_LOAD', false)
          reject(error)
        })
      })
    },
  },
}

export default activitiesModule
